import { render } from "./EditClosureSummary.vue?vue&type=template&id=5b0c83d6"
import script from "./EditClosureSummary.vue?vue&type=script&lang=js"
export * from "./EditClosureSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__